"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  Drafts: '草稿',
  Remote_Groups: '雲端資料',
  Auth_Home_Create_Anonymous_Account_Title: '建議之後在程式內綁定帳戶，避免資料流失',
  Auth_Home_Create_Anonymous_Account_Button: '遊客登入',
  Auth_Home_Open_Social_Network_Account_Link: '已經有連接的帳戶',
  Auth_Home_Select_Social_Network_Account: '連接下面其中之一的社交平台的帳號',
  Gallery: '圖庫',
  My_Collection: '我的收藏',
  Column_Type_Name_Text: '短語',
  Column_Type_Name_Number: '數字',
  Column_Type_Name_Long: '段落',
  Column_Type_Name_Boolean: '是／否',
  Input_Content_Here: '在此輸入內容',
  Tags: '標籤',
  Title: '標題',
  Subtitle: '副標題',
  My_Database: '我的資料庫',
  Edit: '編輯',
  Create: '新增',
  Data: '資料',
  Icon: '圖示',
  Add: '新增',
  Confirm: '確認',
  Cancel: '取消',
  Please_Input_Description_Here: '在此輸入描述',
  Description: '描述',
  Actions: '動作',
  Generic_Delete_Item_Title: '留意',
  Generic_Delete_Item_Message: '是否刪除此欄目',
  Search: '搜尋',
  Search_Database: '搜尋資料庫',
  Click_Here_to_Add_New_Column: '點擊新增',
  Label: '標籤',
  Loading: '加載中',
  Group_Follow_Confirm_Title: '是否關注此資料庫？',
  Group_Follow_Confirm_Text: '關注後，你可以在「已關注的資料庫」列表裡的捷徑找到此資料庫',
  Group_Unfollow_Confirm_Title: '是否取消關注此資料庫？',
  Group_Unfollow_Confirm_Text: '取消關注後，「已關注的資料庫」列表裡的資料庫捷徑將被移除',
  Item_Follow_Confirm_Title: '是否關注此欄目？',
  Item_Follow_Confirm_Text: '關注後，你可以在「已關注的欄目」列表裡的捷徑找到此欄目',
  Item_Unfollow_Confirm_Title: '是否取消關注此欄目？',
  Item_Unfollow_Confirm_Text: '取消關注後，「已關注的欄目」列表裡的欄目捷徑將被移除',
  Followed_Databases: '已關注的資料庫',
  Followed_Items: '已關注的欄目',
  Item_Edit_Open_Desc_Text: '編輯備注',
  Item_Edit_Open_Gallery_Text: '編輯圖庫',
  Edit_Label: '編輯標籤',
  Edit_Content: '編輯內容',
  Rows_Edit_Add_New_Data: '新增資料',
  Column_Edit_For_Boolean_Switch_Reminder: '是／否',
  Close: '關閉',
  Copy: '複製',
  Copied: '已複製',
  Open_External_Link: '打開外部連接',
  Error_on_Open_External_Link: '打開外部連接時發生錯誤',
  No_Data: '沒有資料',
  Delete: '刪除',
  Terms_of_Use: '使用守則',
  Privacy_Policy: '私隱條款',
  Upload: '上傳',
  Ref_Row_Not_Found_Title: '無法找到相關資料',
  Ref_Row_Not_Found_Subtitle: '可能原作者已經刪除此資料',
  Filter_No_Option: '沒有篩選選項',
  Remote_Items_No_Data: '用戶沒有輸入資料',
  Settings: '設定',
  Link_to_Google: '連接谷歌帳戶',
  Link_to_Facebook: '連接臉書帳戶',
  Link_to_Accounts: '連接社交網絡帳戶',
  Google: 'Google',
  Facebook: 'Facebook',
  Link_to_Accounts_Reminder: '成功連接帳戶後，你便可以跨裝置/平台登陸你的帳戶',
  Unknown_Username: '未命名用戶',
  Account_Linked: '帳戶已經連接',
  Sign_Out: '登出',
  Auth_Home_Creating_Anonymous_Account: '登入中⋯',
  Group_Edit_Set_Public_Title: '公開資料庫',
  Public: '公開',
  Group_Edit_Set_Public_Caption: '若不公開, 你亦可以將此資料庫的ID分享給好友, 在搜尋頁面搜尋。',
  Input_Tag_Here: '在此輸入標籤',
  Group_Edit_Tags_Caption: '當公開資料庫後，用戶可以通過標籤搜尋到此資料庫',
  Filter_Add_Custom_Query: '自訂／搜尋',
  Row_Edit_Filterable_Switch_Caption: "如果你關閉此選項，在此欄目的資料將不會在篩選器中出現",
  Row_Edit_Filterable_Switch_Title: '內容是否可以被篩選',
  Row_Edit_Filterable_Switch_Name: '可篩選',
  Label_Edit_Existing_Options: '現時存在的標籤',
  Row_Settings: '欄目設定',
  Input_Any_Label: '在此輸入標籤',
  Sort: '排序',
  Remark: '備注',
  Item_Edit_Open_Remark_Text: '編輯備注',
  Done: '完成',
  Remote_Items_Contribute_Item: '協助新增資料',
  Remote_Items_Contribute_Reminder: '資料庫擁有者會審核你提交的資料。在審核期間，該資料為非公開，只供你本人查看或使用（例如篩選）。',
  Details: '詳情',
  Got_It: '明白',
  Remote_Groups_Delete_Title: '是否刪除此資料庫？',
  Remote_Groups_Delete_Msg: '資料庫你創建的欄目都會被刪除。此動作無法還原。',
  Mandatory_Title_Placeholder: '標題（必須填寫）',
  Pending: '審核中',
  Rejected: '已拒絕',
  Approved: '已批核',
  Reject: '拒絕',
  Approve: '批准',
  Remote_Item_Reject_Title: '是否拒絕此資料的加入申請？',
  Remote_Item_Reject_Msg: '除非原作者再次提交申請，此資料將會在等待列表中移除。',
  Remote_Item_Approve_Title: '是否批准此資料的加入申請？',
  Remote_Item_Approve_Msg: '此資料將會加入你的資料庫，其他玩家可以查看且篩選。',
  Item_Edit_Open_Adv_Settings: '進階設定',
  Basic: '基本',
  Advanced: '進階',
  Item_Edit_Menu_Excel: '資料列',
  Item_Edit_Menu_Settings: '設定',
  Item_Edit_Group_Owner_Editable_Title: '賦予資料庫的擁有者編輯此欄目的權限',
  Item_Edit_Group_Owner_Editable_Msg: '當此欄目新加入不屬於你的資料庫時才生效。如果你選擇「是」，除了你之外，資料庫擁有者也可以編輯你的資料。',
  Editable: '可編輯',
  Detach: '移除',
  Remote_Item_Detach_Title: '是否從當前資料庫中脫離？',
  Remote_Item_Detach_Msg: '資料不會被刪除，而是不再屬於當前的資料庫。脫離後的資料可以加入其他資料庫。',
  Remote_Item_Delete_Title: '是否刪除此資料？',
  Remote_Item_Delete_Msg: '「注意」此資料將會被永久刪除。此動作無法還原。',
  Owner: '擁有者',
  My_Contributions: '等待處理',
  Mine: '我的',
  Detached: '已移除',
  Remote_Item_Review_Reminder_Group_Owner_Can_Edit: '作者已賦予您編輯的權限',
  Input_Number_Here: '在此輸入數字',
  Options_With_Same_Label: '與之相同標籤的內容',
  Group_Edit_Set_Receive_Notification_Contribution_Title: '接收通知',
  Group_Edit_Set_Receive_Notification_Contribution_Reminder: '開啟',
  Group_Edit_Set_Receive_Notification_Contribution_Msg: '如果開啟，當有其他用戶在你的資料庫新增／移除資料資料、需要你審核時，你會收到通知。',
  Remote_Groups_Search_Empty_Text: '沒有相關的搜尋結果',
  Remote_Groups_Placeholder: '按右下 + 開始創建資料庫',
  Anonymous_Sign_Out_Btn: '刪除帳戶',
  Anonymous_Sign_Out_Title: '是否刪除帳戶？',
  Anonymous_Sign_Out_Msg: '你正在使用的這個遊客帳戶將會永遠消失，然後應用程式將會跳至登陸頁面',
  Review: '審核',
  Remote_Item_Review_Not_Pending_Reminder: '此資料已經不是等待審核狀態，可能是因為擁有者已經取消／刪除該資料',
  Generic_Incorrect_Number_Input: '輸入的並非數字',
  View: '查看',
  Click_Enter_Key: '按下「輸入鍵」新增',
  Group_Edit_Tag_Not_Saved: '請按下「輸入」鍵',
  Push_Notification_Group_Has_Pending: "你的資料庫（%{title}）有新的資料加入，等待你的審核。點擊查看更多資訊。",
  Push_Notification_Group_Has_Pending_With_Nickname: "%{nickname} 已新增資料到你的資料庫 (%{title})，等待你的審核。點擊查看更多資訊。",
  Push_Notification_Item_Got_Reviewed: "資料庫管理員已經審核你上傳的資料 %{title} 的加入申請。",
  Push_Notification_Item_Got_Approved: "資料庫管理員已經同意加入你上傳的資料 %{title}。",
  Push_Notification_Item_Got_Rejected: "資料庫管理員已經拒絕你上傳的資料 %{title} 的加入申請。",
  Push_Notification_Item_Got_Deleted: "你的資料庫 (%{group_title}) 有資料 (%{item_title}) 由他的作者移除。點擊查看該資料庫。",
  Generic_Error_Message: "有不尋常的錯誤發生。如果問題持續，請聯絡我們的開發團隊。",
  Item_Edit: '編輯欄目',
  Item_Create: '新增欄目',
  Group_Edit: '編輯資料庫',
  Group_Create: '新增資料庫',
  Tag_Sign: '#',
  Time_Gap_Last_Edit_Day: '%{day}天前更新',
  Time_Gap_Last_Edit_Hour: '%{hour}小時前更新',
  Time_Gap_Last_Edit_Minute: '%{minute}分鐘更新',
  Time_Gap_Last_Edit_Unknown: '無法辨識更新日期',
  Swipe_Down_to_Close: '向下拉關閉',
  Click_to_Open_Group: '打開資料庫',
  Attach_to_Group: '加入資料庫',
  Remote_Item_Attach_Title: '是否加入該資料庫：%{group_title}',
  Remote_Item_Attach_Msg_Owner: '由於這是您的資料庫，資料將直接公開。',
  Remote_Item_Attach_Msg_Not_Owner: '資料將會交由資料庫擁有者審核。',
  Share: '分享',
  Group_Title_Mandatory: '資料庫標題（必填）',
  Item_Title_Mandatory: '欄目標題（必填）',
  Dataset_Title: '資料列標題',
  Group_ID_Share_Text: '分享 CoDB 的資料庫 ID：%{id}. 同時也可以在網頁版顯示：%{link}',
  Group_Edit_Auto_Approve_Title: '允許其他用戶直接加入資料',
  Group_Edit_Auto_Approve_Flag: '允許',
  Group_Edit_Auto_Approve_Caption: '如果開啟，其他用戶加入的資料，將會自動公開，而不需要你額外的審核。',
  Check: '查看',
  Push_Notification_Group_Has_Approved: "你的資料庫（%{title}）有新的資料加入。點擊查看更多資訊。",
  Push_Notification_Group_Has_Approved_With_Nickname: "%{nickname} 已新增資料到你的資料庫 (%{title})。點擊查看更多資訊。",
  Filter_Add_Custom_Query_Short_Text: "搜索特定字詞",
  Filter_Add_Custom_Query_Number: "自訂篩選條件",
  Column_Type_Name_Relation: '關連',
  Column_Edit_Relation_Choose_Target_Caption: '從現存欄目中選擇一個',
  Column_Edit_Relation_Current_Selected_Target_Caption: '選擇中的欄目',
  Column_Edit_Relation_No_Item_Selected_Reminder: '從列表中選擇欄目',
  Invalid_Input: '非法輸入',
  Filter_Add_Custom_Query_Relation: '新增「所關連」的資料的搜尋條件',
  Filter_User_Input_Relation_Action_Equal: '等於 (=)',
  Filter_User_Input_Relation_Action_Include: '包含文字',
  Filter_User_Input_Relation_Action_Larger: '大於 (>)',
  Filter_User_Input_Relation_Action_Equal_Larger: '大於或等於 (>=)',
  Filter_User_Input_Relation_Action_Smaller: '小於 (<)',
  Filter_User_Input_Relation_Action_Equal_Smaller: '小於或等於 (<=)',
  Filter_User_Input_Relation_Row_Compare_Placeholder: '條件',
  Dataset_Label: '資料列標題',
  Filter_User_Input_Relation_Action_Switched_On: '是／否：是',
  Filter_User_Input_Relation_Action_Switched_Off: '是／否：否',
  Column_Edit_For_Relation_Empty_List_Reminder: '沒有可供選擇的資料庫欄目（暫時只可以與同一資料庫的欄目連接）。',
  Remote_Items_No_Data_Filtered: '篩選結果為空',
  Remote_Groups_Search_Box_Reminder: '請輸入至少兩個文字',
  Remote_Items_Contribute_Reminder_Auto_Approve: '因為資料庫擁有者開啟了「自動加入」功能，你提交的資料將會馬上公開，無需審核。',
  Remote_Item_Review_Reminder_Group_Owner_Can_Not_Edit: '作者拒絕賦予您編輯的權限',
  Followed_Group_Delete_Confirm_Title: '是否刪除資料庫的連接？',
  Item_Edit_Group_Owner_Editable_Disabled_Msg: '在審核期間，或資料已經採納，此設定不可以更改。',
  Sign_Out_Title: '是否登出現時用戶？',
  Input_Nickname_Here: '在此輸入暱稱',
  Nickname: '暱稱',
  App_Title: 'Co Database',
  App_Slogan: '彈性創建屬於你的資料庫',
  Datasets: '資料欄',
  Remote_Item_Resubmit: '重新提交',
  Remote_Item_Resubmit_Title: '你是否想重新提交該資料欄到現在的資料庫？',
  Remote_Item_Resubmit_Subtitle_Auto_Approve: '由於資料庫自動批准資料欄，你的資料將會馬上公開。',
  Remote_Item_Resubmit_Subtitle_Need_Review: '由於資料庫已經被設置為需要審核，你的資料將會在審核後公開。',
  Auth_Credential_Already_In_Use: '連接失敗。提供的驗證方已經連接了其他帳戶。',
  Followed_Item_Delete_Confirm_Title: '是否刪除所關注的欄目？',
  Back_to_Group: '返回資料庫',
  Remote_Item_Anonymous_Owner: '匿名使用者',
  Remote_Group_Anonymous_Owner: '匿名使用者',
  Time_Gap_Light_Day: '%{day} 天',
  Time_Gap_Light_Hour: '%{hour} 小時',
  Time_Gap_Light_Minute: '%{minute} 分鐘',
  Time_Gap_Light_Unknown: 'N/A',
  Remote_Item_Review_Action_Error: '無法完成審核',
  Criterion: '條件',
  Input_Search_Words_Here: '在此輸入搜尋字詞',
  Item_Share_Text: '通過以下連結查看 CoDB 資料： %{link}',
  Promote_App_Text: '網頁版只擁有基本功能，請下載手機應用取得最齊全功能',
  Link_to_App_Text: '已經安裝了手機應用程式？',
  Link_to_App_Btn_Text: '打開',
  Remote_Group_Search_Fetch_More_Btn: '更多',
  Group_Edit_Set_Public_Unsecure_Caption: '請勿在此應用程式儲存任何敏感資料。需要留意的是無論資料庫設定公開與否，用戶都可以通過搜索資料庫 ID 找到該資料庫。',
  Settings_Join_Slack_Title: '加入我們的 Slack 頻道',
  Settings_Join_Slack_Subtitle: '問題報告、建議、討論等等',
  Link_Open_Failed_Msg: '無法打開連接',
  Contact_Us_Caption: '聯絡我們',
  Column_Display_Unknown_Type_Reminder: '未知資料類型，請嘗試更新應用程式。',
  Item_Contribute: '貢獻',
  Remote_Items_Contribute_Short_Reminder_Auto_Approve: '自動加入資料庫',
  Remote_Items_Contribute_Short_Reminder: '需要審核',
  Remote_Items_Search_Box_Reminder: '例如：紅色、顏色::紅色',
  Column_Edit_Relation_Search_Box_Reminder: '搜索資料庫',
  View_Action_Sheet_Title: '選擇適合你的顯示格式',
  Item_View_Regular_View: '傳統顯示模式',
  Item_View_Simple_View: '簡潔顯示模式',
  Item_View_Only_Title_View: '只顯示標題',
  Sort_Action_Sheet_Title: '你可以在設定頁面管理排序選項',
  Items_Sort_Reserved_Edit_At: '上次編輯',
  Items_Sort_Reserved_Create_At: '創建日期',
  Items_Sort_Reserved_Title: '標題',
  Items_Sort_Reserved_Subtitle: '副標題',
  Row_Edit_Sortable_Switch_Title: '標題是否可以用來排序',
  Row_Edit_Sortable_Switch_Caption: '如果你關閉此選項，在此欄目的資料將不會在排序中出現。此設定只影響此一列的資料。',
  Row_Settings_Edit_Advanced_Settings: '進階選項',
  Column_Edit_Relation_Selected_Count: '已經選擇的數目：%{count}',
  Column_Edit_Relation_Selected_None: '沒有選擇資料',
  Group_Edit_Hidden_Labels_Title: '在篩選器中，隱藏擁有指定標籤的內容',
  Group_Edit_Input_Label_Here: '在此輸入標籤',
  Group_Edit_Hidden_Labels_Caption: '',
  Column_Type_Name_Rate: '評分',
  Rows_Edit_Add_All_Caption: '*長按增加所有現存的標籤',
  Group_Edit_Hidden_Sort_Labels_Title: '讓指定的標籤不會出現在排序選項。注意原生的屬性標籤無法隱藏：標題、副標題、創建時間、編輯時間等。',
  Group_Edit_Quick_Filter_Title: '設定快速篩選',
  Group_Edit_Quick_Filter_Caption: '快速篩選會顯示在資料頁面的頂端',
  Group_Quick_Filter: '快速篩選',
  Quick_Filter_Edit_Page_Title: '設定快速篩選',
  Quick_Filter_Empty_Reminder: '沒有快速篩選選項',
  Advance_Filter_Short: '進階篩選',
  Manage: '管理',
  Reset: '重設',
  Optional_Input: '可選擇性輸入',
  Group_Edit_Sort_Label_Title: '排序功能',
  Group_Edit_Sort_Label_Selection: '打開編輯頁面',
  Group_Edit_Sort_Label_Caption: '顯示／隱藏可供用戶選擇的排序選項。',
  Group_Edit_Adv_Filter_Title: '進階篩選功能',
  Group_Edit_Adv_Filter_Selection: '打開編輯頁面',
  Group_Edit_Adv_Filter_Caption: '顯示／隱藏可供用戶選擇的進階篩選選擇。如果你希望隱藏特定資料的某些欄目，你需要在該特定資料的設定頁面操作。',
  Explore: '探索',
  Popular: '熱門',
  No_Options_Reminder: '沒有選項'
};